import React, { FC, useContext } from 'react'
import { t } from 'ttag'
import { confirmAlert } from './ConfirmAlert'

import { RootContext } from '../app/RootContext'
import { AppRoot } from '../../models3/AppRoot'
import { observer } from 'mobx-react'
import { sendDebugInfoViaRollbar } from '../translation/SendDebugInfo'
import { RecycleIcon } from 'lucide-react'
import './RefetchLocalDatabase.css'

interface IRefetchLocalDatabase {
    appRoot: AppRoot,
}

const RefetchLocalDatabase: FC<IRefetchLocalDatabase> = observer(({ appRoot }) => {
    let rt = useContext(RootContext)

    const refetchMessage = t`Refetch local database` + '...'

    const confirmDeletion = () => {
        const onConfirm = async () => {
            sendDebugInfoViaRollbar(rt!, 'Refetching local database', true)

            if (rt) {
                await rt.project.db.deleteDB()
            }
            await appRoot.reinitializeProjects()
        }

        const confirmLabelWithIcon = (
            <>
                <div><span className="fa fa-solid fa-fw fa-arrows-rotate"></span></div>
                <div>{t`Accept`}</div>
            </>
        )

        confirmAlert({
            overlayClassName: 'refetch-local-database-overlay',
            title: refetchMessage,
            message: t`This will delete the local database for this project and download a new copy from the remote server.`,
            confirmLabel: confirmLabelWithIcon,
            cancelLabel: t`Cancel`,
            onConfirm,
            onCancel: () => {},
        })
    }

    return (
        <button
            type="button"
            className="btn btn-default"
            onClick={confirmDeletion}
        >
            {refetchMessage}
        </button>
    )
})

export default RefetchLocalDatabase